import useHandleTrpcMutation from 'hooks/ui/useHandleTrpcMutation';
import api, { ApiInputs, ApiResponses } from 'lib/trpcClient';
import { useState } from 'react';
import { downloadFileFromTrpc } from 'further-ui/utils';

const useFinancialStatementsExcel = () => {
  const [inFlightInvestorExcelDownloads, setInFlightInvestorExcelDownloads] =
    useState<Set<string>>(new Set());

  const { mutateAsync: downloadExcel } =
    api.periodEndReport.downloadFinancialStatementsExcel.useMutation(
      useHandleTrpcMutation<
        ApiResponses['periodEndReport']['downloadFinancialStatementsExcel'],
        ApiInputs['periodEndReport']['downloadFinancialStatementsExcel']
      >()({
        invalidations: [],
        onMutate: ({ id, investorIds }) => {
          setInFlightInvestorExcelDownloads((prev) => {
            const newSet = new Set(prev);
            investorIds.forEach((investorId) =>
              newSet.add(`${investorId}-${id}`),
            );
            return newSet;
          });
        },
        onSuccess: (result) => {
          downloadFileFromTrpc(result);
        },
        onSettled: (_, __, input) => {
          setInFlightInvestorExcelDownloads((prev) => {
            const newSet = new Set(prev);
            input.investorIds.forEach((investorId) =>
              newSet.delete(`${investorId}-${input.id}`),
            );
            return newSet;
          });
        },
      }),
    );

  const isDownloading = (periodEndReportId: string, investorId: string) => {
    return inFlightInvestorExcelDownloads.has(
      `${periodEndReportId}-${investorId}`,
    );
  };

  return {
    downloadExcel,
    isDownloading,
  };
};

export default useFinancialStatementsExcel;
